import axios from 'axios';

const mcpApi = axios.create({
    withCredentials: true,
    baseURL: '/api/mcp',
});

/** Point the MCP API at the ScaleX backend (e.g. http://localhost:9000/api/mcp). */
export function setMcpApiBase(appUrl) {
    const base = String(appUrl || '').replace(/\/$/, '');
    mcpApi.defaults.baseURL = `${base}/api/mcp`;
}

mcpApi.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401) {
            window.location.href = '/login';
        }
        return Promise.reject(err);
    },
);

export default mcpApi;
